import { render, staticRenderFns } from "./TermOfAcceptanceFormPage.vue?vue&type=template&id=65818590&scoped=true&"
import script from "./TermOfAcceptanceFormPage.vue?vue&type=script&lang=js&"
export * from "./TermOfAcceptanceFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65818590",
  null
  
)

export default component.exports